import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TrackCoreObject } from '../asp/TrackCoreObject';
import { SideViewComponent } from './side-view.component';
import { MsgBoxService } from '../msg-boxes/msg-box.service';

const MAX_SIDE_VIEW_NUM = 3;

@Injectable({
  providedIn: 'root'
})
export class SideViewService {

  private sideViews: Map<TrackCoreObject, SideViewComponent> = new Map();

  constructor(private dialog: MatDialog,
              private msgBoxSrv: MsgBoxService)
  {
  }

  canShow(): boolean {
    return this.sideViews.size < MAX_SIDE_VIEW_NUM;
  }

  showSideView(track: TrackCoreObject) {
    if (this.sideViews.has(track)) {
      this.sideViews.get(track).dialogRaise();
    }
    else if (!this.canShow()) {
      this.msgBoxSrv.showErrorMsg(`Up to ${MAX_SIDE_VIEW_NUM} side view displays can be opened`);
    }
    else {
      let dialogRef = this.dialog.open(SideViewComponent, SideViewComponent.createDialogConfig(track));
      this.sideViews.set(track, dialogRef.componentInstance);

      dialogRef.afterClosed().subscribe(source => {
        this.onSideViewClose(source)
      });
    }
  }

  private onSideViewClose(sideView: SideViewComponent) {
    for (let track of this.sideViews.keys()) {
      if (this.sideViews.get(track) == sideView) {
        this.sideViews.delete(track);
        break;
      }
    }
  }
}
